import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"
import { createPinia } from "pinia"
import i18n from "./lang/i18n";
// import VConsole from "vconsole";

// const vConsole = new VConsole()
// console.log(vConsole);
const pinia = createPinia() //创建pina实例
function setRemUnit() {
  const docEl = document.documentElement
  const clientWidth = docEl.clientWidth

  if (!clientWidth) return

  // 设置根元素的字体大小，假设设计稿宽度为750px
  // const baseSize = 75; // 750 / 10 = 75
  let fontSize = clientWidth / 10
  // 限制最大页面宽度为750px
  if (clientWidth > 750) {
    fontSize = 750 / 18
  } else if (clientWidth >= 500) {
    // 折叠屏
    fontSize = clientWidth / 18
  }

  // 设置一个最小字体大小，防止在小屏幕上字体过小
  const minFontSize = 12 // 你可以根据需要调整
  if (fontSize < minFontSize) {
    fontSize = minFontSize
  }

  docEl.style.fontSize = fontSize + "px"
}
// 初始化
setRemUnit()

// 窗口大小变化时重新设置根元素的字体大小
window.addEventListener("resize", setRemUnit)
// window.addEventListener("beforeunload", (e) => beforeunloadHandler(e))

// function beforeunloadHandler() {
//   if (!platformStore().needSaveLogin) {
//     // 清空所有浏览器内存信息
//     localStorage.clear()
//   }
// }

function getBrowserVersion() {
  const userAgent = navigator.userAgent;
  let version = "";

  // 判断是否为 Chrome 浏览器
  if (/Chrome\/(\S+)/.test(userAgent)) {
    version = userAgent.match(/Chrome\/(\S+)/)[1];
  }
  // 判断是否为 Firefox 浏览器
  else if (/Firefox\/(\S+)/.test(userAgent)) {
    version = userAgent.match(/Firefox\/(\S+)/)[1];
  }
  // 判断是否为 Safari 浏览器
  else if (/Safari\/(\S+)/.test(userAgent)) {
    version = userAgent.match(/Version\/(\S+)/)[1];
  }
  // 判断是否为 Edge 浏览器
  else if (/Edg\/(\S+)/.test(userAgent)) {
    version = userAgent.match(/Edg\/(\S+)/)[1];
  }
  // 判断是否为 Internet Explorer 浏览器
  else if (/MSIE (\S+);/.test(userAgent)) {
    version = userAgent.match(/MSIE (\S+);/)[1];
  }

  return version;
}

const browserVersion = getBrowserVersion();
console.log(browserVersion, 'version');

createApp(App).use(router).use(pinia).use(i18n).mount("#app")
